import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tickets from './pages/Tickets';
import TicketDetail from './pages/TicketDetail';
import Changelog from './pages/Changelog';
import SettingsLayout from './pages/settings/SettingsLayout';
import Profile from './pages/settings/Profile';
import Users from './pages/settings/Users';
import ApiKeys from './pages/settings/ApiKeys';
import Integrations from './pages/settings/Integrations';
import WhatsappPage from './pages/settings/WhatsappPage';
import Categories from './pages/settings/Categories';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import Reports from './pages/Reports';
import OperacionesWhatsapp from './pages/landing/OperacionesWhatsapp';
import { Layout } from './components/Layout';
import { RequireAuth } from './components/RequireAuth';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="/login" element={<Login />} />
        {/* Landing pública (sin auth, sin Layout) */}
        <Route path="/operaciones-whatsapp" element={<OperacionesWhatsapp />} />
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="tickets" element={<Tickets />} />
          <Route path="tickets/:idOrCode" element={<TicketDetail />} />
          <Route path="customers" element={<Customers />} />
          <Route path="customers/:id" element={<CustomerDetail />} />
          <Route path="categories" element={<Navigate to="/admin/settings/categories" replace />} />
          <Route path="reports" element={<Reports />} />
          <Route path="settings" element={<SettingsLayout />}>
            <Route index element={<Navigate to="profile" replace />} />
            <Route path="profile" element={<Profile />} />
            <Route path="users" element={<Users />} />
            <Route path="api-keys" element={<ApiKeys />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="whatsapp" element={<WhatsappPage />} />
            <Route path="categories" element={<Categories />} />
          </Route>
          <Route path="changelog" element={<Changelog />} />
        </Route>
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
